import { render } from "./CarSlider.vue?vue&type=template&id=21ca89ba&scoped=true"
import script from "./CarSlider.vue?vue&type=script&lang=js"
export * from "./CarSlider.vue?vue&type=script&lang=js"

import "./CarSlider.vue?vue&type=style&index=0&id=21ca89ba&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-21ca89ba"

export default script